import { useEffect, useState } from "react";
import { navLinks } from "@/mocks/home";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState("entry");

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 12);
      const ids = navLinks.map((l) => l.id);
      let current = ids[0];
      ids.forEach((id) => {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top <= 140) {
          current = id;
        }
      });
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-colors duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200"
          : "bg-background-50/70 backdrop-blur-sm border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 cursor-pointer">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-play-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-xl tracking-wide text-foreground-950">
            51视频
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className={`whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors cursor-pointer ${
                active === link.id
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#app"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
          >
            下载 App
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 transition-colors hover:bg-background-100 md:hidden"
          >
            <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} aria-hidden="true"></i>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <div className="mx-auto grid max-w-7xl grid-cols-2 gap-2 px-4 py-4">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setMenuOpen(false)}
                className="whitespace-nowrap rounded-md bg-background-100 px-3 py-2.5 text-sm text-foreground-800 transition-colors hover:bg-primary-100 hover:text-primary-700"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#app"
              onClick={() => setMenuOpen(false)}
              className="col-span-2 whitespace-nowrap rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50"
            >
              下载 App
            </a>
          </div>
        </div>
      )}
    </header>
  );
}